export function EditIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M19.977 3.879a2.999 2.999 0 00-4.242 0l-1.537 1.537a.815.815 0 00-.037.037L3.293 16.325a1 1 0 00-.293.707v2.97a1 1 0 001 1.001h2.97a1 1 0 00.706-.293L20.118 8.264a3.001 3.001 0 000-4.244l-.141-.141zm-5.09 3.677l1.555 1.556-9.887 9.89H5v-1.555l9.887-9.89zm2.97.141L16.3 6.142l.848-.849a1 1 0 011.414 0l.141.142a1 1 0 010 1.414l-.848.848z"
      ></path>
    </svg>
  );
}
